import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { safeValue, ConfigService, buildPath } from '@identic/core';
import { BaseService } from '@identic/api';
import { LocationViewModel, LOCATION_DISPLAY_FIELD } from './+state';
import { LocationConstants } from './data-access.constants';

// R(oute)T(oken)
const RT = LocationConstants;

@Injectable({providedIn: 'root'})
export class LocationService extends BaseService<LocationViewModel> {

  constructor(http: HttpClient, config: ConfigService) {
    super(http, buildPath(config.environment.API_BASE_URL, safeValue(config, 'environment.Api.Location', RT.defaultApi)), LOCATION_DISPLAY_FIELD);
  }
}
